import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { AssetCheckListEntity } from "./asset-checklist.entity";
import { AssetCheckListController } from "./asset-checklist.controller";
import { AssetCheckListService } from "./asset-checklist.service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { AssetCheckListAdapter } from "./asset-checklist-adapter";



@Module({
    imports: [
        TypeOrmModule.forFeature([AssetCheckListEntity]),
    ],
    controllers: [AssetCheckListController],
    providers: [AssetCheckListService, ApplicationExceptionHandler, AssetCheckListAdapter]
})
export class AssetCheckListModule {

}